import styled, { css } from 'styled-components';

import BaseSelect from 'Elements/Input/Select';
import { InputBox, DropDown } from 'Elements/Input/Select/Select.styled';

export const Select = styled(BaseSelect)`
    ${({ theme }) => css`
        flex-grow: 1;
        width: 100%;
        margin-bottom: 0.5rem;

        ${InputBox} {
            font-weight: 700;
            font-size: 1rem;
            line-height: 1.25;
            color: ${theme.colors.accents[5].hex};
            border-color: ${theme.colors.accents[5].hex};
            min-height: 3.25rem;
            padding: 0.25rem 0.75rem;
        }

        ${DropDown} {
            max-height: 11rem;
            border-color: ${theme.colors.accents[5].hex};
            color: ${theme.colors.accents[5].hex};
        }

        @media ${theme.breakpoints.medium.media} {
            margin-right: 1rem;
            margin-bottom: 0;
        }

        @media ${theme.breakpoints.large.media} {
            max-width: 24rem;

            ${InputBox} {
                min-height: 3.5rem;
                padding: 0.75rem;
            }
        }
    `}
`;
